export default __webpack_public_path__ + "static/media/check.b9f06514.svg";